import { render } from "./Page10.vue?vue&type=template&id=f91eec96&scoped=true"
import script from "./Page10.vue?vue&type=script&lang=js"
export * from "./Page10.vue?vue&type=script&lang=js"

import "./Page10.vue?vue&type=style&index=0&id=f91eec96&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91eec96"]])

export default __exports__